import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../lib/api";
import { flag, fmtData, fmtEUR, fmtDate, countryName } from "../../lib/format";

export default function AdminEsims() {
  const { t, i18n } = useTranslation();
  const [esims, setEsims] = useState([]);

  useEffect(() => {
    api.get("/admin/esims").then(({ data }) => setEsims(data));
  }, []);

  return (
    <div data-testid="admin-esims">
      <div className="overline mb-2">{t("admin.esims")}</div>
      <h1 className="font-display font-black text-3xl md:text-4xl tracking-tightest mb-8">{t("admin.esims")}</h1>
      <div className="card-soft overflow-auto !rounded-3xl">
        <table className="w-full text-sm" data-testid="admin-esims-table">
          <thead className="bg-cobalt-50 text-xs uppercase tracking-widest">
            <tr>
              <th className="text-left px-4 py-3">ICCID</th>
              <th className="text-left px-4 py-3">{t("common.email")}</th>
              <th className="text-left px-4 py-3">{t("common.plans")}</th>
              <th className="text-left px-4 py-3">{t("common.country")}</th>
              <th className="text-left px-4 py-3">{t("dash.dataUsed")}</th>
              <th className="text-left px-4 py-3">{t("common.status")}</th>
              <th className="text-left px-4 py-3">Created</th>
            </tr>
          </thead>
          <tbody>
            {esims.map((e) => (
              <tr key={e.id} className="border-t border-ink-100">
                <td className="px-4 py-3 font-mono text-xs">{e.iccid}</td>
                <td className="px-4 py-3">{e.email}</td>
                <td className="px-4 py-3">{e.plan_snapshot?.name}</td>
                <td className="px-4 py-3">{flag(e.plan_snapshot?.country_iso2)} {countryName(e.plan_snapshot?.country_iso2, i18n.language, e.plan_snapshot?.country)}</td>
                <td className="px-4 py-3">{fmtData(e.data_used_mb)} / {fmtData(e.data_total_mb)}</td>
                <td className="px-4 py-3">
                  <span className="text-[10px] uppercase tracking-widest px-2 py-1 border border-success/30 bg-success/10 text-success">{e.status}</span>
                </td>
                <td className="px-4 py-3 text-ink-500">{fmtDate(e.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
